import { HStack } from "@/storybook-components";

const WrapperComponent = ({ children, ...rest }: any) => {
  return (
    <HStack
      top={{ base: "auto", xl: 4, lg: 4 }}
      justifyContent="space-between"
      position="fixed"
      zIndex={5}
      {...rest}
    >
      {children}
    </HStack>
  );
};

export default WrapperComponent;
